import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const CustomerLoginLayout = loadable(
  () => import('./customerLogin.layout'),
  {
    fallback: <FullPageLoader />,
  }
);
